import { IconButton, Table, Text } from '@nimbus-ds/components';

function LocationsListBodySkeleton(): JSX.Element | null {
  const { Row, Cell, Body } = Table;

  return (
    <Body>
      <Row>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="small">
          <IconButton.Skeleton />
        </Cell>
      </Row>
      <Row>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="small">
          <IconButton.Skeleton />
        </Cell>
      </Row>
      <Row>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="base">
          <Text.Skeleton width="80%" />
        </Cell>
        <Cell padding="small">
          <IconButton.Skeleton />
        </Cell>
      </Row>
    </Body>
  );
}

export default LocationsListBodySkeleton;
